import { apiClient as api } from './apiClient';
import type { AuraFarmaciaResponse } from './auraApi';

// El Listado de transmisiones sobre Gescom (#221): todos los IDs son de Gescom, y la provincia es la de la farmacia.
export interface FarmaciaLookup {
  id: number;
  _Name: string;
  provincia?: string;
}

export interface ClienteLookup {
  id: number;
  _Name: string;
  codigoGF?: string;
}

export interface EmpleadoLookup {
  id: number;
  nombreAbreviado?: string;
  nombreCompleto: string;
}

export interface TransmisionVendedor {
  transmisionId: number;
  vendedorId: number;
  cliente?: ClienteLookup;
}

export interface TransmisionComprador {
  transmisionId: number;
  compradorId: number;
  cliente?: ClienteLookup;
}

export interface TransmisionEmpresa {
  transmisionId: number;
  empresaId: number;
}

export interface Transmision {
  id: number;
  numeroGesfar?: number;
  responsableId: number;
  fechaCreacion: string;
  usuarioAlta?: string;
  fechaModificacion?: string;
  usuarioModificacion?: string;
  farmaciaId: number;
  tramoFact?: number;
  horario?: number;
  localRegimenId?: number;
  notas?: string;
  notasGestion?: string;
  fecha: string;
  precio?: number;
  factor?: number;
  estadoId?: number;
  enVenta_Exclusiva?: boolean;
  enVentaDesde?: string;
  enVentaHasta?: string;
  origen?: string;
  vendedores: TransmisionVendedor[];
  compradores: TransmisionComprador[];
  empresas?: TransmisionEmpresa[];
  // Lookup data
  farmacia?: FarmaciaLookup;
  responsable?: EmpleadoLookup;
}

export interface UpdateTransmisionRequest {
  fecha: string;
  estadoId: number;
  notasGestion?: string;
}

export interface AsesorOption {
  id: number;
  nombre: string;
}

export const getAsesores = async (): Promise<AsesorOption[]> => {
  try {
    const response = await api.get('/transmisiones/asesores');
    return response.data;
  } catch (error) {
    console.error('Error fetching asesores:', error);
    return [];
  }
};

export const getTransmisiones = async (estadoId?: number): Promise<Transmision[]> => {
  try {
    const url = estadoId !== undefined ? `/transmisiones?estadoId=${estadoId}` : '/transmisiones';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching transmisiones:', error);
    throw error;
  }
};

export const updateTransmision = async (id: number, fecha: string, estadoId: number, notasGestion?: string): Promise<void> => {
  try {
    await api.put(`/transmisiones/${id}`, { fecha, estadoId, notasGestion });
  } catch (error) {
    console.error(`Error updating transmision ${id}:`, error);
    throw error;
  }
};

export const refreshTransmisiones = async (estadoId?: number): Promise<Transmision[]> => {
  try {
    const url = estadoId !== undefined ? `/transmisiones/refresh?estadoId=${estadoId}` : '/transmisiones/refresh';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error refreshing transmisiones:', error);
    throw error;
  }
};

// Los titulares actuales de la farmacia, de Gescom, para la ventana del detalle (#221). Solo hay titulares: el modo
// «empleados» de la ventana no se usa en el listado.
export const getTitularesTransmision = async (idFarmacia: number): Promise<AuraFarmaciaResponse> => {
  const response = await api.get<AuraFarmaciaResponse>(`/transmisiones/farmacias/${idFarmacia}/titulares`);
  return response.data;
};
